<template>
  <div>
    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Type</label>
              <select class="form-control" v-model="type">
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
            </div>

            <div class="col-md-6" v-if="auth.user.tmsUser === 'institution'">
              <label for="inlineFormInput">Fund User</label>
              <select class="form-control" v-model="fundUser">
                <option value="merchant">Merchant</option>
                <option value="agent">Agent</option>
              </select>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Amount"
                placeholder="Amount"
                v-model="amount"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <label>
                Enter Wallet ID
                <span class="text-danger"
                  >(Kindly Ensure Correct Wallet Id )</span
                >
              </label>
              <fg-input type="text" placeholder="walletId" v-model="walletId">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Reference"
                placeholder="Reference"
                v-model="reference"
              >
              </fg-input>
            </div>
            <!-- <div class="col-md-6">
              <fg-input
                type="text"
                label="Description"
                placeholder="Description"
                v-model="description"
              >
              </fg-input>
            </div> -->
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Send
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
export default {
  data() {
    return {
      type: "debit",
      walletId: "",
      reference: "",
      amount: "",
      description: "",
      fundUser: "",
    };
  },
  computed: {
    ...mapState(["loading", "auth"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    submit() {
      this.$confirm(`${this.type.toUpperCase()} Wallet?`).then(async () => {
        try {
          const url =
            this.auth.user.tmsUser === "institution"
              ? `${process.env.VUE_APP_API_URL}/funding/institution/load`
              : `${process.env.VUE_APP_API_URL}/funding/merchant/load`;
          const res = await axios.post(url, {
            type: this.type,
            walletId: this.walletId,
            reference: this.reference,
            amount: this.amount,
            description: this.description,
            fundUser: this.fundUser,
          });
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message: message || "Successful",
          });
          this.walletId = "";
          this.reference = "";
          this.amount = "";
          this.description = "";
        } catch (err) {
          const data = err.response
            ? err.response.data
            : { message: err.toString() };
          this.setNotification({
            type: "danger",
            message: data.message || "Failed",
          });
        }
      });
    },
  },
};
</script>
<style></style>
